"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BatteryFullOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29,11.71H27V8a1,1,0,0,0-1-1H3A1,1,0,0,0,2,8V23a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V19.29h2a1,1,0,0,0,1-1V12.71A1,1,0,0,0,29,11.71ZM25,22H4V9H25V22Zm3-4.71H27V13.71h1Z"/><rect x="6" y="11" width="17" height="9"/>';
var BatteryFullOutlineSVG = function BatteryFullOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BatteryFullOutlineSVG = BatteryFullOutlineSVG;
BatteryFullOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BatteryFullOutlineSVG);
exports.default = _default;